'use client';

import { BunnyCdnPlayer } from '@/components/bunny-cdn-player';
import { GotipathPlayer } from '@/components/gotipath-player';
import {
  ClassResourceViewModel,
  LessonViewModel,
} from '@hidayahlab/academy-suite-corelib';
import VideoPlayer from './VideoPlayer';

type ResourceVideoPlayerProps = {
  resource: ClassResourceViewModel;
  lesson: LessonViewModel;
  bunnyCdnLibraryId: string;
};

export default function ResourceVideoPlayerFreeLesson({
  resource,
  lesson,
  bunnyCdnLibraryId,
}: ResourceVideoPlayerProps) {
  return (
    <>
      {resource.videoStoreType === 'YOUTUBE' && resource.videoUrl && (
        <VideoPlayer lessonId={lesson.id} url={resource.videoUrl} />
      )}

      {resource.videoStoreType === 'GOTIPATH' && resource.videoId && (
        <GotipathPlayer url={resource.videoId} />
      )}

      {resource.videoStoreType === 'BUNNY_CDN' &&
        resource.videoId &&
        bunnyCdnLibraryId && (
          <BunnyCdnPlayer
            url={resource.videoId}
            libraryId={bunnyCdnLibraryId}
          />
        )}
    </>
  );
}
